const FileUpload = (props) => {
  return (
    <div className="file-upload">
      <div className="image-upload-wrap">
        <input
          className="file-upload-input"
          type="file"
          onChange={props.coverChange}
          accept="image/*"
        />
        <div className="drag-text">
          <h3>Arraste e solte a imagem para alterar a capa</h3>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
